import React from 'react';
import ReactMarkdown from 'react-markdown';
import { useLocale } from '../contexts/LocaleContext';
import { FAQ_ITEMS } from './faq-items';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { cn } from '@/lib/utils';

type FaqListProps = {
  className?: string;
};

export const FaqList: React.FC<FaqListProps> = ({ className }) => {
  const { t } = useLocale();

  return (
    <Accordion type="single" collapsible className={cn('w-full', className)}>
      {FAQ_ITEMS.map((faq) => (
        <AccordionItem key={faq.questionKey} value={faq.questionKey}>
          <AccordionTrigger className="text-sm font-medium">
            {t(faq.questionKey)}
          </AccordionTrigger>
          <AccordionContent>
            <div className="prose prose-sm max-w-none text-muted-foreground dark:prose-invert prose-p:text-muted-foreground prose-li:text-muted-foreground prose-strong:text-foreground prose-a:text-foreground">
              <ReactMarkdown>{t(faq.answerKey)}</ReactMarkdown>
            </div>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};
